import { createLookupService } from "api-client";

const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || "";

export const lookupService = createLookupService(apiBase);
